import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { loadAllFiles } from 'loot-core/client/actions';

import { useAuth } from '../../hooks/useAuth';
import { useLocalPref } from '../../hooks/useLocalPref';
import { View } from '../common/View';
import { useSessionFlag } from '../../hooks/useSessionFlag';

export function Bootstrap() {
  const [budgetId] = useLocalPref('id');
  const { isAuthenticated, hasRemoteAccount } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = useSelector(state => state.user?.data?.id || null);
  const [_, setPostAuth] = useSessionFlag('postAuth');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const postAuth = params.get('postAuth');
    const isYnabFlow = postAuth === 'ynab';

    function setPostAuthFlag() {
      if (postAuth) {
        setPostAuth(postAuth);
      }
    }

    async function run() {
      if (isAuthenticated) {
        const allFiles = await dispatch(loadAllFiles());
        const files = (allFiles || []).filter(
          f => f.userId === userId || !f.cloudFileId,
        );
        if (budgetId) {
          navigate('/planning');
        } else {
          if (files && files.length > 0 && !isYnabFlow) {
            navigate('/budgets');
          } else {
            setPostAuthFlag();
            navigate('/onboarding');
          }
        }
      } else {
        setPostAuthFlag();
        navigate(hasRemoteAccount ? '/login' : '/signup');
      }
    }

    run();
  }, []);

  return <View style={{ maxWidth: 450, marginTop: -30 }} />;
}
